export const LogoCollapsed = () => {
    return (
        // <svg
        //     width="32"
        //     height="32"
        //     viewBox="0 0 32 32"
        //     fill="none"
        //     xmlns="http://www.w3.org/2000/svg"
        // >
        //     <path
        //         fillRule="evenodd"
        //         clipRule="evenodd"
        //         d="M17.8163 7.68711C17.9511 7.71935 18.0852 7.75505 18.2184 7.7942C19.2486 8.09684 20.209 8.59943 21.045 9.27327C21.8809 9.9471 22.576 10.779 23.0904 11.7214C23.6048 12.6639 23.9286 13.6984 24.0432 14.766C24.1579 15.8336 24.0611 16.9132 23.7584 17.9434C23.4558 18.9736 22.9532 19.9341 22.2794 20.77C21.6055 21.6059 20.7736 22.301 19.8312 22.8154C19.1955 23.1624 18.5179 23.4227 17.8165 23.5905L22.6188 28.3319H26.9468L23.5081 24.8919C24.1398 24.3735 24.7182 23.7905 25.2335 23.1513C26.2201 21.9274 26.9559 20.5212 27.399 19.0129C27.8421 17.5047 27.9838 15.9239 27.8159 14.3609C27.6481 12.7979 27.1741 11.2833 26.4209 9.90344C25.6677 8.52363 24.6502 7.30568 23.4263 6.31913C22.2024 5.33258 20.7962 4.59675 19.2879 4.15365C18.8039 4.01144 18.3123 3.90028 17.8163 3.82043V7.68711ZM13.4438 3.92588C13.1495 3.98795 12.8577 4.06107 12.5692 4.14503V4.54277H11.4226C10.9977 4.71472 10.5823 4.91127 10.1784 5.13173C10.1004 5.17434 10.0228 5.21779 9.94581 5.26208V5.41753H12.5693V6.29202H11.6948V7.16651H10.8203V6.29202H9.07132V5.85477V5.8167C8.76956 6.02693 8.47778 6.25085 8.19689 6.48771V8.04074H6.6638C6.64044 8.06917 6.61722 8.09771 6.59412 8.12637C6.38835 8.38164 6.19348 8.64484 6.00991 8.91525H6.44773V9.78974H5.57324V9.60837C5.37342 9.95102 5.19073 10.3034 5.02588 10.6642H5.57334V11.5387H4.69885V12.4132H4.38606C4.30511 12.7025 4.23519 12.9943 4.17636 13.2881H8.0829C8.2666 12.6761 8.521 12.0891 8.84003 11.5387H8.19698H7.75973H7.32248V12.4132H6.44799V10.6642H7.32248V8.91525H8.19698V10.6642H9.42516C9.46553 10.6116 9.50657 10.5594 9.54826 10.5077C9.75171 10.2553 9.96957 10.0157 10.2005 9.7901H9.07132V8.91561H11.2611C11.4026 8.81773 11.5472 8.72424 11.6948 8.63532V8.04112H12.5693V8.17804C12.8544 8.0502 13.1465 7.93893 13.4438 7.84469V3.92588ZM7.99157 17.6605H4.11523C4.33781 18.9595 4.77366 20.2145 5.40672 21.3742C6.1599 22.754 7.17748 23.972 8.40136 24.9585C9.62524 25.9451 11.0315 26.6809 12.5397 27.124C13.8677 27.5141 15.252 27.6706 16.6308 27.5879V23.7835C15.6142 23.873 14.5893 23.7714 13.6092 23.4834C12.5791 23.1808 11.6186 22.6782 10.7826 22.0044C9.94671 21.3305 9.25168 20.4987 8.73724 19.5562C8.4099 18.9565 8.15975 18.3196 7.99157 17.6605ZM16.9418 7.16624H14.3183V4.54277H16.9418V7.16624ZM15.193 5.41748H16.0675V6.29197H15.193V5.41748ZM4.69885 14.1626H7.32232V16.786H4.69885V14.1626ZM5.57324 15.037H6.44773V15.9115H5.57324V15.037ZM9.94581 7.16636H9.07132V8.04085H9.94581V7.16636Z"
        //         fill="white"
        //     />
        // </svg>
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="5.85646" cy="5.8565" r="4.40191" fill="#195CE5" />
            <circle cx="26.144" cy="26.1441" r="4.40191" fill="#B2EBFF" />
            <path
                d="M16 20.4756C18.4718 20.4756 20.4755 18.4718 20.4755 16V14.8812C20.4755 12.4094 22.4793 10.4056 24.951 10.4056H26.0699C28.5417 10.4056 30.5455 8.40188 30.5455 5.93011C30.5455 3.45835 28.5417 1.45459 26.0699 1.45459C23.5982 1.45459 21.5944 3.45835 21.5944 5.93011V7.049C21.5944 9.52076 19.5906 11.5245 17.1189 11.5245H16C13.5282 11.5245 11.5245 13.5283 11.5245 16V17.1189C11.5245 19.5907 9.52071 21.5944 7.04895 21.5944H5.93007C3.4583 21.5944 1.45454 23.5982 1.45454 26.07C1.45454 28.5417 3.4583 30.5455 5.93007 30.5455C8.40183 30.5455 10.4056 28.5417 10.4056 26.07V24.9511C10.4056 22.4793 12.4094 20.4756 14.8811 20.4756H16Z"
                fill="#7DC0FC"
            />
            <path
                d="M26.0698 1.53076C28.4993 1.53076 30.4692 3.50069 30.4692 5.93018C30.4692 8.35963 28.4992 10.3286 26.0698 10.3286H24.9506C22.4368 10.3288 20.3989 12.3674 20.3989 14.8813V16.0005C20.3986 18.4296 18.4296 20.3987 16.0004 20.3989H14.8813C12.3674 20.3989 10.3288 22.4368 10.3286 24.9507V26.0698C10.3286 28.4993 8.35959 30.4692 5.93013 30.4692C3.50065 30.4692 1.53072 28.4993 1.53072 26.0698C1.5308 23.6404 3.5007 21.6714 5.93013 21.6714H7.04927C9.56317 21.6712 11.601 19.6326 11.601 17.1187V16.0005C11.601 13.571 13.571 11.6011 16.0004 11.6011H17.1186C19.6325 11.6011 21.6712 9.56321 21.6713 7.04932V5.93018C21.6713 3.50074 23.6404 1.53084 26.0698 1.53076Z"
                stroke="url(#paint0_linear_7518_50121)"
                stroke-opacity="0.5"
                stroke-width="0.15311"
            />
            <foreignObject
                x="-0.0765564"
                y="-0.0765107"
                width="22.0983"
                height="22.0983"
            >
                <div
                    // xmlns="http://www.w3.org/1999/xhtml"
                    // style="backdrop-filter:blur(0.77px);clip-path:url(#bgblur_0_7518_50121_clip_path);height:100%;width:100%"
                    style={{
                        backdropFilter: "blur(0.26px)",
                        clipPath: "url(#bgblur_0_7517_50106_clip_path)",
                        height: "100%",
                        width: "100%",
                    }}
                ></div>
            </foreignObject>
            <g data-figma-bg-blur-radius="1.5311">
                <path
                    d="M10.4717 5.96315C10.4717 3.47314 8.45311 1.45459 5.96311 1.45459C3.4731 1.45459 1.45454 3.47314 1.45454 5.96315C1.45454 8.45316 3.4731 10.4717 5.96311 10.4717H6.96501C9.45502 10.4717 11.4736 12.4903 11.4736 14.9803V15.9822C11.4736 18.4722 13.4921 20.4907 15.9821 20.4907C18.4721 20.4907 20.4907 18.4722 20.4907 15.9822C20.4907 13.4922 18.4721 11.4736 15.9821 11.4736H14.9802C12.4902 11.4736 10.4717 9.45506 10.4717 6.96505V5.96315Z"
                    fill="url(#paint1_radial_7518_50121)"
                    fill-opacity="0.8"
                />
                <path
                    d="M5.96333 1.49268C8.4321 1.4928 10.4331 3.49459 10.4331 5.96338V6.96533C10.4332 9.47626 12.469 11.512 14.9799 11.5122H15.9819C18.4507 11.5122 20.4525 13.5132 20.4526 15.9819C20.4526 18.4508 18.4508 20.4526 15.9819 20.4526C13.5131 20.4525 11.5122 18.4507 11.5122 15.9819V14.98C11.512 12.4691 9.47621 10.4333 6.96529 10.4331H5.96333C3.49454 10.4331 1.49275 8.43214 1.49263 5.96338C1.49263 3.49451 3.49446 1.49268 5.96333 1.49268Z"
                    stroke="url(#paint2_linear_7518_50121)"
                    stroke-opacity="0.5"
                    stroke-width="0.076555"
                />
            </g>
            <defs>
                <clipPath
                    id="bgblur_0_7518_50121_clip_path"
                    transform="translate(0.0765564 0.0765107)"
                >
                    <path d="M10.4717 5.96315C10.4717 3.47314 8.45311 1.45459 5.96311 1.45459C3.4731 1.45459 1.45454 3.47314 1.45454 5.96315C1.45454 8.45316 3.4731 10.4717 5.96311 10.4717H6.96501C9.45502 10.4717 11.4736 12.4903 11.4736 14.9803V15.9822C11.4736 18.4722 13.4921 20.4907 15.9821 20.4907C18.4721 20.4907 20.4907 18.4722 20.4907 15.9822C20.4907 13.4922 18.4721 11.4736 15.9821 11.4736H14.9802C12.4902 11.4736 10.4717 9.45506 10.4717 6.96505V5.96315Z" />
                </clipPath>
                <linearGradient
                    id="paint0_linear_7518_50121"
                    x1="26.5057"
                    y1="1.90773"
                    x2="26.9385"
                    y2="11.0054"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="white" stop-opacity="0.5" />
                    <stop offset="1" stop-color="white" stop-opacity="0" />
                </linearGradient>
                <radialGradient
                    id="paint1_radial_7518_50121"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(10.9726 10.9727) rotate(48.5726) scale(10.8122 4.41003)"
                >
                    <stop stop-color="white" stop-opacity="0" />
                    <stop offset="1" stop-color="white" stop-opacity="0.8" />
                </radialGradient>
                <linearGradient
                    id="paint2_linear_7518_50121"
                    x1="10.9726"
                    y1="1.45459"
                    x2="9.6073"
                    y2="10.4163"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="white" />
                    <stop offset="1" stop-color="white" stop-opacity="0" />
                </linearGradient>
            </defs>
        </svg>
    )
}
